import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CargandoService {
  private estadoCargando = new BehaviorSubject<boolean>(false);
  estadoCargando$ = this.estadoCargando.asObservable();

  @Output() CambioEstadoCargadnoEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() ocultarCargando: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  cambiarEstadoCargando(estado: boolean) {
    this.estadoCargando.next(estado);
    this.CambioEstadoCargadnoEmitter.emit(estado);
    if (!estado) {
      this.ocultarCargando.emit(true);
    }
  }
}
